var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0742 10L9.99121 18.0321",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1787 13.6978V6.30216C17.1787 6.19148 17.1493 6.08279 17.0935 5.98719C17.0378 5.8916 16.9576 5.81252 16.8612 5.75806L10.2987 2.04882C10.2049 1.99579 10.099 1.96793 9.99121 1.96793C9.88344 1.96793 9.7775 1.99579 9.68367 2.04882L3.12117 5.75806C3.02482 5.81252 2.94466 5.8916 2.88888 5.98719C2.8331 6.08279 2.80371 6.19148 2.80371 6.30216V13.6978C2.80371 13.8085 2.8331 13.9172 2.88888 14.0128C2.94466 14.1084 3.02482 14.1875 3.12117 14.2419L9.68367 17.9512C9.7775 18.0042 9.88344 18.0321 9.99121 18.0321C10.099 18.0321 10.2049 18.0042 10.2987 17.9512L16.8612 14.2419C16.9576 14.1875 17.0378 14.1084 17.0935 14.0128C17.1493 13.9172 17.1787 13.8085 17.1787 13.6978V13.6978Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0931 5.98649L10.0741 10L2.88985 5.98563",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8298 11.6024V7.8524L6.58148 3.80225",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStock);
export default __webpack_public_path__ + "static/media/stock.89d523afa5e6ce50e276e8beef9f49e3.svg";
export { ForwardRef as ReactComponent };